<div class="section pl-11px pt-17px pb-17px">
  <div class="centered-vert hov-cursor-p ml-7px" (click)="expanded = !expanded">
    <span class="ink-10-v3 fs-11px fw-600 tt-uppercase">{{ config.sectionLabelKey }}</span>
    <span class="ink-10-v3 ml-5px fw-600">
      <span *ngIf="expanded" class="gh-font-icon-arrow-down-small"></span>
      <span *ngIf="!expanded" class="gh-font-icon-arrow-right-small"></span>
    </span>
  </div>
  <div *ngIf="expanded" class="mt-7px">
    <div class="drag-area" cdkDropList (cdkDropListDropped)="drop($event)">
      <ng-template ngFor let-i="index" let-item [ngForOf]="collection.items">
        <gh-nav-list-item [item]="item" [config]="config" *ngIf="seeMore || i < config.visibleItemsCount"></gh-nav-list-item>
      </ng-template>
    </div>
    <div *ngIf="collection.totalCount - config.visibleItemsCount > 0" class="fs-11px mt-1px ml-23px ink-20-v3 hov-cursor-p" (click)="seeMore = !seeMore">
      <div *ngIf="!seeMore">See {{ collection.totalCount - config.visibleItemsCount }} more</div>
      <div *ngIf="seeMore">See less</div>
    </div>
  </div>
</div>
